import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Gallery.css';
import { mainGalleryData } from '../../../data/maingallery';

const Gallery = () => {
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);

  const handleViewMoreClick = () => {
    navigate('/about/gallery');
  };

  return (
    <section className="gallery-section">
      <div className="container">
        <div className="section-header">
          <h2>University Gallery</h2>
          <p>Explore our campus, events, and university life through images</p>
          <div className="header-underline"></div>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {mainGalleryData.map((image) => (
            <div 
              key={image.id} 
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
            >
              <div className="image-container">
                <img 
                  src={image.image} 
                  alt={image.title}
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <div className="gallery-footer">
          <button className="view-more-btn" onClick={handleViewMoreClick}>
            View Complete Gallery
            <span className="arrow">→</span>
          </button>
        </div>
      </div>

      {/* ===== MODAL ===== */}
      {selectedImage && (
        <div className="gallery-modal" onClick={() => setSelectedImage(null)}>
          <div 
            className="gallery-modal-content" 
            onClick={e => e.stopPropagation()}
          >
            <span 
              className="gallery-modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ✖
            </span>

            <img 
              src={selectedImage.image} 
              alt={selectedImage.title} 
            />

            {/* <h3>{selectedImage.title}</h3>
            <p>{selectedImage.category}</p> */}
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
